<template>
        <el-dialog title="新增" top=0 :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
            
               <el-form-item label="考勤年月" prop="FDate">
               <el-date-picker type="month" placeholder="选择日期" v-model="form.FDate"  style="width: 100%"></el-date-picker>
                </el-form-item>   
                <el-form-item label="用户名称" prop="FUserId">
                <sy-select v-model="form.FUserId" valueKey="FID"  
                               optionData="server/system/Staff.ashx?cmd=GetStafOptions&FDeptId=0">
                </sy-select>  
                </el-form-item>
                <el-form-item label="出勤天数">
                <el-input v-model="form.FDays"></el-input>
                </el-form-item>
                  <el-form-item label="是否全勤" prop="FIsFull" >
                   <el-radio-group v-model="form.FIsFull">
                        <el-radio :label="0" >否</el-radio>
                        <el-radio :label="1" >是</el-radio> 
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注">
                <el-input type='textarea' v-model="form.FNote"></el-input>
                </el-form-item> 
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
</template>

<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        data() {
            return {
                form: {id:0,userId:0,certificate:''},
                rules: {
                    FDate: [{ type: 'date', required: true, message: '请选择考勤年月', trigger: 'blur' }],
                    FUserId: [{required: true,message: '选择用户', trigger: 'blur'}]
                },
                loading:false,
                editFormVisible:false,
               
            }
        },
        methods: {
            switchLoading(flag){
                this.loading = flag
            },
            _openEdit(record) {
                this.editFormVisible = true
                this.form = Object.assign({},record)
            },
            _openAdd(record) {
                this.editFormVisible = true;
                this.form = Object.assign({FID:0,FUserId:0,FIsFull:0},record);
            },
            save:function () {
                util.saveForm("server/business/Attendance.ashx?cmd=Save",this.$refs.form,this.form,this.switchLoading,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Attendance_Edit.vue